import { atomWithHash } from 'jotai-location'

export const companyIdAtom = atomWithHash('companyId', '')
export const orderIdAtom = atomWithHash('orderId', '')
